import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { constants } from 'src/app/shared/constants';
import { MandatoryNotificationCategory, NotificationCategory, NotificationPreferences } from 'src/app/shared/model/notification';
import { AlertService } from 'src/app/shared/services/alert.service';
import { UserPreferenceService } from 'src/app/shared/services/userpreferences.service';
import { Utilities } from 'src/app/shared/utilities';

@Component({
  selector: 'app-notification-preferences',
  templateUrl: './notification-preferences.component.html',
  styleUrls: ['./notification-preferences.component.scss']
})
export class NotificationPreferencesComponent implements OnInit {

  notificationCategories: string[];
  notificationPreferences: NotificationPreferences;
  preferencesForm = new FormGroup({});

  constructor(
    private userPreferenceService: UserPreferenceService,
    private translateService: TranslateService,
    private alertService: AlertService
  ) {}

  ngOnInit(): void {
    const allCategories = Utilities.enumToStringArray(NotificationCategory);
    const allMandatoryCategories = Utilities.enumToStringArray(MandatoryNotificationCategory);
    this.notificationCategories = allCategories.filter((cat) => !allMandatoryCategories.includes(cat));
    this.setFormValues();
  }

  setFormValues() {
      const notifications = this.userPreferenceService.userPreferences.notificationPreference;
      this.notificationPreferences = notifications !== undefined ? notifications : new NotificationPreferences();
      this.notificationCategories.forEach(cat => {
        if (this.notificationPreferences[cat] !== undefined) {
          this.preferencesForm.addControl(cat, new FormControl(this.notificationPreferences[cat] === 1));
        } else {
          this.preferencesForm.addControl(cat, new FormControl(false));
        }
    });
  }

  /**
   * note: have to get number value (1 or 0) out of boolean value sent by the checkboxes
   */
  update() {
    this.notificationPreferences = new NotificationPreferences();
    this.notificationCategories.forEach(cat => {
      if (this.preferencesForm.value[cat] !== undefined) {
        this.notificationPreferences.preferences[cat] = this.preferencesForm.value[cat] ? 1 : 0;
      }
    });
    this.userPreferenceService.updateUserNotificationPreferences(this.notificationPreferences)
    .then( res => {
      // update context preferences and local storage with new notification preferences
      this.userPreferenceService.userPreferences.notificationPreference = res.notificationPreference;
      sessionStorage.setItem(constants.local.userPreferences, JSON.stringify(res));
      this.alertService.addSuccess(this.translateService.instant('pages.dashboard.user.notificationPreferencesUpdate'));
    })
    .catch( err => {
      this.alertService.handlerError(err);
    });
  }

}
